// Set each platform to true only after 1.0.9 is approved and available there.
// Web rollout changes menu discovery; native capability checks still own access.
export const APP_PRIVACY_RELEASED_PLATFORMS = Object.freeze({ ios: true, android: true });

export function isAppPrivacyReleased(platform) {
    return APP_PRIVACY_RELEASED_PLATFORMS[platform] === true;
}
